module.exports = __webpack_public_path__ + "static/img/8.28e7179.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/8.png
// module id = x7T6
// module chunks = 0